import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './style.sass';

export default class Navigation extends Component {
  static propTypes = {
    links: PropTypes.object
  }

  // static defaultProps
  // state = {}

  render() {
    const { className, links } = this.props;

    return (
      <div className={classnames('Navigation', className)}>
        {
          Object.keys(links).map(function(link) {
            var href = links[link]['path'];
            var title = links[link]['title'];
            return (
              <span className="Navigation-link-span">
                &raquo; &nbsp;
                <a href={href} className="navigation-link">
                  {title}
                </a>
              </span>
            )
          })
        }
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Navigation/index.js